// extracted by mini-css-extract-plugin
export default {"contentHeader":"WasteCollectionEditPage_contentHeader__hKxw9"};